<template>
  <b-card class="mt-1">
    <div class="d-flex justify-content-end align-items-center mb-2">
      <span class="text-secondary">Last updated as of: {{ topBox['Report created'] || 'N/A' }}</span>
    </div>
    <b-row class="mb-1 ml-0 mr-0">
      <b-col
        cols="12"
        md="3"
      >
        <div
          v-for="(value, key) in topBox"
          :key="key"
          class="mb-2"
        >
          <h3 class="mb-0 text-secondary font-weight-bold">
            {{ key }}
          </h3>
          <h4 class="mb-3">
            <router-link
              v-if="key.toLowerCase() === 'provider' && providerId"
              :to="`/providers/provider-details/${providerId}`"
            >{{ value }}</router-link>
            <template v-else>{{ value }}</template>
          </h4>
        </div>
        <h3 class="mb-0 text-secondary font-weight-bold mt-3">
          Product Summary
        </h3>
        <ul style="padding-left: 0px; list-style-type: none;">
          <li
            v-for="(item, index) in productSummary"
            :key="index"
            class="mb-0"
            style="position: relative; padding-left: 15px; font-size: 1rem;"
          >
            <span style="position: absolute; left: 0;">▸</span>
            {{ item }}
          </li>
        </ul>
      </b-col>
      <b-col
        cols="12"
        md="9"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-table-simple>
              <tbody>
                <tr
                  v-for="(value, key) in keyInfo.leftTbl"
                  :key="key"
                >
                  <td><b>{{ key }}</b></td>
                  <td>
                    <router-link
                      v-if="key.toLowerCase() === 'product type' && productTypeId"
                      :to="`/data/product-types/${productTypeId}`"
                    >{{ value }}</router-link>
                    <template v-else>{{ value }}</template>
                  </td>
                </tr>
              </tbody>
            </b-table-simple>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-table-simple>
              <tbody>
                <tr
                  v-for="(value, key) in keyInfo.rightTbl"
                  :key="key"
                >
                  <td><b>{{ key }}</b></td>
                  <td>{{ formatIsoDate(value) }}</td>
                </tr>
              </tbody>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="8"
          >
            <b-table-simple>
              <tbody>
                <tr
                  v-for="(value, key) in keyInfo.bottomTbl"
                  :key="key"
                >
                  <td><b>{{ key }}</b></td>
                  <td>
                    <template v-if="Array.isArray(value)">
                      <span
                        v-for="(item, i) in value"
                        :key="i"
                      >
                        <router-link :to="`/data/underlyings/${item.UNDERLYINGCODE}`">{{ item.NAME }}</router-link><span v-if="i < value.length - 1">, </span>
                      </span>
                    </template>
                    <template v-else-if="value && typeof value === 'object'">
                      <router-link :to="`/data/counterparties/${value.COUNTERPARTYID}`">{{ value.NAME }}</router-link>
                    </template>
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <span
                      v-else
                      v-html="value"
                    />
                  </td>
                </tr>
              </tbody>
            </b-table-simple>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BTableSimple,
} from 'bootstrap-vue'
import { formatIsoDate } from '@/utils/formatters'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTableSimple,
  },
  props: {
    keyInfo: {
      type: Object,
      default: () => ({
        leftTbl: {},
        rightTbl: {},
        bottomTbl: {},
      }),
    },
    topBox: {
      type: Object,
      default: () => ({}),
    },
    productSummary: {
      type: Array,
      default: () => ([]),
    },
    reportNumber: {
      type: [String, Number],
      default: '',
    },
    detailsId: {
      type: [String, Number],
      default: '',
    },
    productTypeGuideId: {
      type: [String, Number],
      default: 0,
    },
    productTypeId: {
      type: [String, Number],
      default: null,
    },
    providerId: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    formatIsoDate,
  },
}
</script>
